import { ISendDomainMessage } from "../Interfaces/ISendDomainMessage";

export const SendDomainMessage: ISendDomainMessage = {
    data: {},
    isProgress: false
}